module.exports = __webpack_public_path__ + "img/pbn.19c67264.svg";